import { render, staticRenderFns } from "./OpenOfferItemPriceManipulationModal.vue?vue&type=template&id=8d04a9f4&scoped=true"
import script from "./OpenOfferItemPriceManipulationModal.vue?vue&type=script&lang=ts"
export * from "./OpenOfferItemPriceManipulationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d04a9f4",
  null
  
)

export default component.exports